"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontsId = exports.default = void 0;
var _getAppConfig = _interopRequireDefault(require("../constants/getAppConfig"));
const fontsId = exports.fontsId = 'icis-fonts';
const getFonts = () => {
  if (document.getElementById(fontsId) !== null) {
    return;
  }
  const {
    urls: {
      client
    }
  } = (0, _getAppConfig.default)();
  const head = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.id = fontsId;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = "".concat(client, "/fonts/fonts.css");
  head.appendChild(link);
};
var _default = exports.default = getFonts;